import 'twin.macro';

import PopupContainer from 'components/Atoms/PopupContainer';
import Button from 'components/Molecules/Button';
import { TextField } from 'components/Molecules/material-ui';
import useInputHandlers from 'hooks/useInputHandlers';
import PropTypes from 'prop-types';
import React from 'react';

function PopupPassword({ isOpen, message, onClose, onSubmit, ...props }) {
	const { values, errorMessages, handleTextChange, checkRequireText } = useInputHandlers({
		password: ''
	});

	const handleSubmit = e => {
		e.preventDefault();

		const errorMessage = checkRequireText({ target: { name: 'password', value: values.password } });

		if(!errorMessage) {
			onSubmit(values.password);
		}
	};

	return (
		<PopupContainer {...props} className='flex flex-col items-center justify-center p-10' isOpen={isOpen} onClose={onClose} showNavigation>
			<p className='text-center font-bold text-14 portrait:mt-20'>Podaj hasło</p>
			{message && <p className='text-center font-semibold text-red-0 mt-20'>{message}</p>}
			<form onSubmit={handleSubmit}>
				<TextField
					tw='portrait:mt-24 portrait:mb-15 landscape:mb-10'
					value={values.password}
					onChange={handleTextChange}
					label='Hasło'
					name='password'
					type='password'
					error={!!errorMessages.password}
					helperText={errorMessages.password}
					InputProps={{
						onBlur: checkRequireText
					}}
				/>

				<Button tw='mx-auto' onClick={onClose} primary type='submit'><p>Ok</p></Button>
				<p className='text-center text-09 mt-10'>Jeżeli jesteś akcjonariuszem Smart Faktor S.A. i nie posiadasz jeszcze hasła dostępu do specjalnej sekcji przeznaczonej dla akcjonariuszy spółki, wyślij do nas maila lub zadzwoń. Szczegóły w sekcji Kontakt.</p>
			</form>
		</PopupContainer>
	);
}

PopupPassword.propTypes = {
	onClose: PropTypes.func.isRequired
};

export default React.memo(PopupPassword);
